import { NvTableCellProps } from 'shared/components/nv-table';
import { MentorshipProgramCustomCommunication } from 'redux/schemas/models/mentorship-program-custom-communications';

export enum ColumnID {
  MESSAGE_TYPE = 'messageType',
  SUBJECT = 'subject',
  TO = 'to',
  STATUS = 'status',
  OPTIONS = 'options',
}

export type CellProps = NvTableCellProps<MentorshipProgramCustomCommunication>;
